// extracted by mini-css-extract-plugin
export default {"card":"card_card__QYaR0","container":"card_container__3Zo+h","reverse":"card_reverse__pHNHk"};